import { compose } from 'recompose';
import Header from '../Header';
import { withStyles } from '@material-ui/core';
import Footer from './components/Footer';
import { inject, observer } from 'mobx-react';
import { withUserProfile } from '../../../../../../userProfile/userProfileContext';
import { AppLoading } from '../../../../../../loaders/loaders';
import { withSnackbar } from 'notistack';
import { getProNumbers } from '../../DriverPopUp/utils';
import ProInfo from './components/ProInfo';
import StopImagesDialog from '../../DriverPopUp/StopImagesDialog';
import { STOP_IMAGES } from '../../DriverPopUp/StopImagesDialog/getBlobImages';
import styles from '../DeliveryProInfo/style';
import WithDrawer from '../../../Common/Drawer/WithDrawer';
import { fetchAndSetStaticData } from '../utils';

@inject('DispatchStore')
@observer
class ProDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      proDetails: this.props.proDetails,
      viewStopImages: null
    };
  }

  componentDidMount() {
    const {
      DispatchStore,
      userData: { userProfile }
    } = this.props;
    fetchAndSetStaticData({ DispatchStore, userProfile }).then(() => {
      this.updateProDetails();
    });
  }

  componentDidUpdate(prevProps) {
    const { proDetails } = this.props;
    if (
      prevProps.proDetails?.pickupShipmentId !== proDetails?.pickupShipmentId ||
      prevProps.proDetails?.seq !== proDetails?.seq ||
      prevProps.proDetails?.proId !== proDetails?.proId
    ) {
      this.updateProDetails();
    }
  }

  updateProDetails = () => {
    this.setState({
      proDetails: this.props.proDetails
    });
  };

  onViewStopImages = () => {
    const { pickupInfo, driverDetails, userData } = this.props;
    this.setState({
      viewStopImages: {
        terminalCode: userData.userProfile.terminal.code,
        routeId: pickupInfo.routeId,
        stopId: driverDetails?.stops?.[0]?.stopId,
        isStopCompleted: pickupInfo.isCompleted,
        proNumbers: getProNumbers(driverDetails?.stops?.[0]?.shipments || [])
      }
    });
  };

  onHideStopImages = () => {
    this.setState({
      viewStopImages: null
    });
  };
  render() {
    const { proId } = this.state.proDetails ?? {};
    const { onClose, classes, pickupInfo, driverDetails } = this.props;
    const viewStopImages = this.state.proDetails
      ? {
          terminalCode: this.props.userData.userProfile.terminal.code,
          routeId: pickupInfo.routeId,
          stopId: driverDetails?.stops?.[0]?.stopId,
          isStopCompleted: pickupInfo.isCompleted,
          proNumbers: getProNumbers(driverDetails?.stops?.[0]?.shipments || [])
        }
      : null;
    return this.state.proDetails ? (
      <>
        <Header
          onClose={onClose}
          proNumber={proId}
          onViewStopImages={this.onViewStopImages}
          hideViewProImages={!pickupInfo.isCompleted}
        />
        <div id="drawerContent" className={`${classes.contentStyles} customScroll`}>
          <ProInfo
            classes={classes}
            proDetails={this.state.proDetails}
            DispatchStore={this.props.DispatchStore}
            isWarehousePickup={pickupInfo.isWarehousePickup}
          />
          {this.state.proDetails && this.state.viewStopImages ? (
            <StopImagesDialog
              showImages={this.state.proDetails.proId || Object.keys(STOP_IMAGES)[0]}
              {...viewStopImages}
              stops={driverDetails?.stops ?? []}
              close={this.onHideStopImages}
              apiName={this.props.proImageApiName || 'GetImages'}
              dialogRootClass={classes.dialogRootClass}
            />
          ) : null}
        </div>
        <Footer onClose={onClose} />
      </>
    ) : (
      <AppLoading />
    );
  }
}

export default compose(withStyles(styles), withUserProfile, withSnackbar, WithDrawer)(ProDetails);
